import { MdOpenInNew } from "react-icons/md";
import OutlineCard from "./outlineCard";
import UrlSlugCard from "./urlCard";
import H1Card from "./h1Card";
import ContentCard from "./contentCard";
import MetaDataCard from "./metaDataCard";
import LinkCard from "./linksCards";
function getNameFromURL(url) {
  return url.replace("www.", "").split(".")[0];
}

export default function CompetitorCard({
  type,
  index,
  url,
  analysis,
  content,
  general,
}) {
  return (
    <>
      <div className={`${index == 0 ? "mb-10 " : "my-10 "} `}>
        <div className="w-full px-4 py-2 rounded-2xl bg-white">
          <div className=" border-b-[1px] border-black py-2">
            <div className="flex items-start justify-between">
              {/* Card Header */}
              <div className="w-9/12 break-words">
                <div className="flex items-center break-words ">
                  <label className="text-lg font-bold break-words text-black flex items-center gap-1 ">
                    {content?.favicon_url && (
                      <img src={content?.favicon_url} className="w-5 h-5" />
                    )}
                    <span className="text-base font-bold text-black ms-2">
                      {content?.website_name}
                    </span>
                  </label>
                </div>
              </div>

              <label
                className={`text-lg  font-bold ${
                  index == 0
                    ? "text-yellow-500"
                    : index == 1
                    ? "text-slate-400"
                    : index == 2
                    ? "text-yellow-700"
                    : "text-black"
                }`}
              >
                #{index + 1}
              </label>
            </div>

            <a 
              href={url.full}
              target="_blank"
              className="text-xs text-blue-600 hover:underline hover:text-blue-800 break-words "
            >
              {url.full}
            </a>
          </div>
          {/* Card Body */}
          {/* Plan */}
          {type === "plan" && (
            <>
              <OutlineCard analysis={analysis} content={content}></OutlineCard>
            </>
          )}

          {/* Url */}
          {type === "slug" && (
            <>
              <UrlSlugCard analysis={analysis} content={content}></UrlSlugCard>
            </>
          )}

          {/* Title */}
          {type === "title" && (
            <>
              <H1Card analysis={analysis} content={content}></H1Card>
            </>
          )}

          {/* Content */}
          {type === "content" && (
            <>
              <ContentCard
                general={general}
                analysis={analysis}
                content={content}
              ></ContentCard>
            </>
          )}

          {/* Meta Data */}
          {type === "meta" && (
            <>
              <MetaDataCard
                general={general}
                analysis={analysis}
                content={content}
              ></MetaDataCard>
            </>
          )}

          {/* Linking */}
          {type === "linking" && (
            <>
              <LinkCard
                general={general}
                analysis={analysis}
                content={content}
                index={index}
              ></LinkCard>
            </>
          )}
        </div>
      </div>
    </>
  );
}
